
















import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
	}
});

@Component
export default class InfosLegales extends Props {

}
